import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Images } from './assets';
import './override-reacttooltip.scss';

const ToolTipInsideIcon = styled.img`
  height: 100%;

  width: auto;

  margin-top: 5px;

  margin-left: auto;

  margin-right: auto;

  padding-right: 5px;
`;

const ToolTipTextOne = styled.p`
  color: #000000;
  font-size: 12px;
  font-family: 'Montserrat Regular';
`;

const ToolTipTextOneContent = styled.p`
  color: #000000;
  font-family: 'Montserrat Regular';
  word-break: break-word;
  font-size: 12px;
`;

const ToolTipTextTwo = styled.p`
  color: #000000;

  font-size: 12px;

  font-family: 'Montserrat SemiBold';
`;

const CustomToolTip = ({ textOne, textTwo, ToolTipIcon = true }) => {
  return (
    <div style={{ padding: 10 }}>
      <ToolTipTextOne style={{ display: 'flex' }}>
        {ToolTipIcon && (
          <ToolTipInsideIcon
            style={{ width: 20 }}
            src={Images.Exclamation}
            alt={'info'}
          />
        )}
        <ToolTipTextOneContent>{textOne}</ToolTipTextOneContent>
      </ToolTipTextOne>

      {textTwo && (
        <Fragment>
          <br />

          <ToolTipTextTwo style={{ marginLeft: 15 }}>{textTwo}</ToolTipTextTwo>
        </Fragment>
      )}
    </div>
  );
};

export default CustomToolTip;
